import { Paper, Table, TableBody, TableContainer } from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";

import MyTablePagination from "@components/pagination/TablePagination";
import Scrollbar from "@components/Scrollbar";
import { TableNoData, TableSkeleton } from "@components/table";
import useLocales from "@hooks/useLocales";
import generate from "@utils/generateElem";
import TableHeadCustom from "src/pages/Documents/Finance/table/tableHeadCustom";

import { IPurchaseOrderListItem } from "../../types/purchaseOrderTypes";
import { PurchaseOrderDraftTableRow } from "./PurchaseOrderDraftTableRow";

interface IPurchaseOrderDraftTableProps {
  rows: IPurchaseOrderListItem[];
  loading: boolean;
  page: number;
  rowsPerPage: number;
  hasNextPage: boolean;
  onPageChange: (event: any, newPage: number) => void;
  onRowsPerPageChange: (event: SelectChangeEvent<HTMLInputElement>) => void;
}

export const PurchaseOrderDraftTable: React.FC<
  IPurchaseOrderDraftTableProps
> = ({
  rows,
  loading,
  page,
  rowsPerPage,
  hasNextPage,
  onPageChange,
  onRowsPerPageChange,
}) => {
  const { translate } = useLocales();
  const isNotFound = !loading && rows.length === 0;

  const TABLE_HEAD = [
    { id: "poNumber", label: translate("po_number"), align: "left" },
    {
      id: "vendorCompanyName",
      label: translate("vendor_company_name"),
      align: "left",
    },
    {
      id: "customerCompanyName",
      label: translate("customer_company_name"),
      align: "left",
    },
    { id: "createdDate", label: translate("created_date"), align: "left" },
    { id: "actions", label: translate("actions"), align: "right" },
  ];

  return (
    <Paper>
      <Scrollbar>
        <TableContainer sx={{ minWidth: 800 }}>
          <Table size="small">
            <TableHeadCustom headLabel={TABLE_HEAD} />
            <TableBody>
              {loading ? (
                generate(<TableSkeleton />)
              ) : isNotFound ? (
                <TableNoData isNotFound={isNotFound} />
              ) : (
                rows.map((row) => (
                  <PurchaseOrderDraftTableRow key={row.id} row={row} />
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Scrollbar>

      <MyTablePagination
        page={page - 1}
        count={rows.length}
        rowsPerPage={rowsPerPage}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        hasNextPage={hasNextPage}
        hidePageNo={true}
        loading={loading}
        dataLength={rows.length}
      />
    </Paper>
  );
};
